import React from 'react';
import {
  H5MigrationMode,
  getH5MigrationExternalGuideUrl,
  getH5MigrationMode,
} from '@/utils/h5-migration';

function normalizePathname(pathname: string) {
  if (!pathname || pathname === '/') {
    return '/';
  }
  return pathname.replace(/\/+$/, '') || '/';
}

/** 当前页已与引导目标 URL 同址时不再 replace，避免同域路径循环跳转 */
function isAlreadyAtH5GuideTargetUrl(): boolean {
  if (typeof window === 'undefined') {
    return false;
  }
  const url = getH5MigrationExternalGuideUrl();
  if (!url) {
    return false;
  }
  try {
    const target = new URL(url, window.location.href);
    const cur = window.location;
    return (
      target.origin === cur.origin &&
      normalizePathname(target.pathname) === normalizePathname(cur.pathname) &&
      target.search === cur.search
    );
  } catch {
    return false;
  }
}

export function useH5MigrationGuard() {
  const [mode, setMode] = React.useState<H5MigrationMode>(() => {
    if (typeof window === 'undefined') {
      return 'disabled';
    }
    return getH5MigrationMode(window.location.pathname);
  });

  React.useLayoutEffect(() => {
    if (typeof window === 'undefined') {
      return;
    }

    const nextMode = getH5MigrationMode(window.location.pathname);
    setMode(nextMode);

    if (nextMode === 'guide' && !isAlreadyAtH5GuideTargetUrl()) {
      const url = getH5MigrationExternalGuideUrl();
      if (url) {
        window.location.replace(url);
      }
    }
  }, []);

  return mode;
}
